import styled from "styled-components";

export const Text = styled.p`
  color: #fff;
  text-align: center;
`;
